import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Table, Row, Col } from 'react-bootstrap';
import * as Common from './Common';

const Tran_data_unlock_request = (props) => {

    const sid = sessionStorage.getItem('sessionId');
    const [unlockData, setUnlockData] = useState([]);

    const [msg, setMsg] = useState('');
    const [unlockStatus, setUnlockStatus] = useState("");

    useEffect(() => {
        if (props.show) {
            Common.callApi(Common.apiDataUnlockRequest, [sid, "getData", JSON.stringify(props.logObject)], result => {
                let resp = JSON.parse(result);
                setUnlockStatus(resp.unlock_status);
                setMsg(Common.getMessage('MSG0012'));
            });
        }
    }, [props.show]);

    const handleRequest = () => {
        Common.callApi(Common.apiDataUnlockRequest, [sid, "sendRequest", JSON.stringify(props.logObject)], result => {
            console.log(result);
        });
        props.onHide();
    }

    return (
        <div>
            <Modal  {...props} animation={false} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{msg}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{unlockStatus === "P" ? "Request already pending." :
                    unlockStatus === "R" ? "Your previous request has been rejected, you want to send unlock request again?" :
                        "Do you want to send unlock request ?"}
                </Modal.Body>
                <Modal.Footer>
                    {
                        unlockStatus === "P" ?
                            <Button variant="secondary" onClick={() => props.onHide()}>
                                Ok
                            </Button>
                            :
                            <>
                                <Button variant="secondary" onClick={() => props.onHide()}>
                                    No
                                </Button>
                                <Button variant="primary" onClick={handleRequest}>
                                    Yes
                                </Button>
                            </>
                    }
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Tran_data_unlock_request
